import {SurveyQuestion} from "crqlar-react-common/dist/models/survey/surveyQuestion.model";
import {SurveyAnswerContext, surveyQuestionTitle} from "./surveyAnswer.util";

/**
 * The text tier of the two question markers - the same two facts the DOM tier renders as a red
 * asterisk and a lock, spelled out for media that have no DOM: PDF, print, DOCX, XLSX and CSV.
 *
 * WHY it is shared: four exporters used to hand-roll this join, and they had drifted - the
 * spreadsheet dropped `required` altogether while the documents carried it. One helper per fact
 * means a question reads the same in every artefact a guest's answer can end up in.
 */

/** Separates the meta tokens that annotate a question in text media: `Long text · Sensitive`. */
export const SURVEY_MARKER_SEPARATOR = ' · ';

/** The text tier's Required marker - the same glyph the DOM tier draws, minus the colour. */
export const SURVEY_REQUIRED_MARKER = '*';

/** `How was your stay? *` - a title carrying its own Required marker. */
export const surveyQuestionTitleWithMarkers = (
    question: SurveyQuestion,
    ctx: SurveyAnswerContext
): string => (
    `${surveyQuestionTitle(question, ctx)}${question.isRequired ? ` ${SURVEY_REQUIRED_MARKER}` : ''}`
);

/** The Sensitive token, or nothing. Undefined rather than '' so it drops out of a join. */
export const surveySensitiveLabel = (
    question: SurveyQuestion,
    ctx: SurveyAnswerContext
): string | undefined => (
    question.isSensitive ? ctx.t('Sensitive') : undefined
);

/** Joins meta tokens, skipping the absent ones: `Long text · Sensitive`. */
export const surveyQuestionMetaText = (
    ...parts: (string | undefined | false)[]
): string => parts.filter(Boolean).join(SURVEY_MARKER_SEPARATOR);
